module.exports = __webpack_public_path__ + "img/arrow_up_circle.f947bcaf.svg";